module.exports = __webpack_public_path__ + "static/media/performance-bg.d5da922e.png";